/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import axios from 'axios';
import {
  Paper,
  Grid,
  Box,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Input,
  Button,
} from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { GateComponent } from '../territorycard/Gate';
import { Gate, Building, KakaoAddress } from '../../types';
import { IconLabelButton, EditToggleButton } from './Buttons';
import config from '../../config';
import { ConfirmDialog } from '../utils/AlertDialog';

interface BuildingComponentProps {
  building: Building;
  handleBuildingUpdate: (id: number, name: string, address: string) => void;
  handleBuildingDelete: (id: number) => () => void;
  currAddress: KakaoAddress;
  editable: boolean;
}

export function BuildingComponent(props: BuildingComponentProps) {
  const {
    building,
    handleBuildingUpdate,
    handleBuildingDelete,
    currAddress,
    editable,
  } = props;

  const [name, setName] = React.useState<string>(building.name);
  const [address, setAddress] = React.useState<string>(building.address);
  const [tmpAddress, setTmpAddress] = React.useState<string>('');
  const [gates, setGates] = React.useState<Gate[]>(building.gates as Gate[]);
  const [type, setType] = React.useState('');
  const [isLock, setIsLock] = React.useState(true);
  const [openConfirmDialog, setOpenConfirmDialog] = React.useState(false);
  const [selectedId, setSelectedId] = React.useState(-1);

  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event.target.value);
  };

  const handleNameChanged = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value;
    handleBuildingUpdate(building.id, text, address);
    setName(text);
  };

  const handleAddressChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value;
    handleBuildingUpdate(building.id, name, text);
    setAddress(text);
  };

  const handleGateDelete = (id: number) => () => {
    setSelectedId(id);
    setOpenConfirmDialog(true);
  };

  const handleConfirmDialogClose = (answer: string) => async () => {
    switch (answer) {
      case 'confirm':
        try {
          const id = selectedId;
          await axios.delete(`${config.api.url}/mdsouth/gates/${id}`);
          setGates(
            gates.filter((gate: Gate) => {
              return gate.id !== id;
            }),
          );
        } catch (error) {
          console.log(error);
        }
        break;
      case 'cancel':
      default:
        break;
    }
    setOpenConfirmDialog(false);
  };

  const handleGateAdd = async () => {
    try {
      const { data } = await axios.post(`${config.api.url}/mdsouth/gates`, {
        name: '',
        buildingId: building.id,
      });
      setGates([
        ...gates,
        {
          id: data.id,
          name,
          households: [],
          buildingId: building.id,
        },
      ]);
    } catch (error) {
      console.log(error);
    }
  };

  const handleGateUpdate = async (id: number, name: string) => {
    try {
      const { data } = await axios.put(
        `${config.api.url}/mdsouth/gates/${id}`,
        {
          name,
          buildingId: building.id,
        },
      );
    } catch (error) {
      console.log(error);
    }
  };

  const handleBuidlingEditToggle = () => {
    setIsLock(!isLock);
  };

  const addressUpdateConfirmed = () => {
    setAddress(tmpAddress);
    handleBuildingUpdate(building.id, name, address);
  };

  React.useEffect(() => {
    if (currAddress.road_address != null) {
      setTmpAddress(currAddress.road_address.address_name);
    }
  }, [currAddress]);

  const title = name === '' ? address.split(' ').at(-1) : name;

  return (
    <Paper
      elevation={!isLock ? 2 : 0}
      sx={{ p: 1, display: 'flex', flexDirection: 'column' }}
    >
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="baseline"
      >
        <Typography variant="h6">{title} </Typography>

        <Typography variant="h6" align="right">
          {editable ? (
            <>
              <EditToggleButton
                isLock={isLock}
                visible
                onClick={handleBuidlingEditToggle}
              />
              <IconLabelButton
                visible
                iconName="delete"
                label="삭제"
                onClick={handleBuildingDelete(building.id)}
              />
            </>
          ) : null}
        </Typography>
        {/* <Typography variant="body1"> 형태: {type}</Typography>
        <Typography variant="body1"> 주소: {address}</Typography> */}
      </Grid>
      <Typography variant="subtitle2">{address}</Typography>
      {/* <BuildingView name={name} type={type} address={address} /> */}
      {!isLock ? (
        <Grid
          container
          // direction="row"
          justifyContent="flex-start"
          // alignItems="center"
          sx={{ mt: 2, mb: 2 }}
        >
          <Grid item xs={6}>
            <FormControl sx={{ m: 1 }} size="small">
              <InputLabel id="름emo-select-small">건물이름</InputLabel>
              <OutlinedInput
                id="component-simple"
                value={name}
                onChange={handleNameChanged}
                label="건물이름"
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl sx={{ m: 1, width: '80%' }} size="small">
              <InputLabel id="demo-select-small">형태</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={type}
                label="형태"
                onChange={handleTypeChange}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value="다세대">다세대</MenuItem>
                <MenuItem value="아파트">아파트</MenuItem>
                <MenuItem value="상가">상가</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography variant="body2">주소</Typography>
              <FormControl sx={{ ml: 1.5, width: '80%' }} size="small">
                {/* <InputLabel id="demo-select-small">주소</InputLabel> */}
                <Input
                  // disabled
                  id="component-simple"
                  placeholder="지도에서 클릭해서 가져오세요"
                  value={tmpAddress}
                  onChange={handleAddressChanged}
                />
              </FormControl>
              <Button onClick={addressUpdateConfirmed}> 적용 </Button>
            </Box>
          </Grid>
        </Grid>
      ) : null}

      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ mt: 1 }}
      >
        {gates.map((gate: Gate) => (
          <GateComponent
            key={gate.id}
            gate={gate}
            handleGateUpdate={handleGateUpdate}
            handleGateDelete={handleGateDelete}
            editable={!isLock && editable}
            buildingLock={isLock}
          />
        ))}
        <IconLabelButton
          visible={!isLock && editable}
          iconName="add"
          label="입구정보추가"
          onClick={handleGateAdd}
        />
      </Grid>
      <ConfirmDialog
        open={openConfirmDialog}
        title="입구정보 삭제"
        message="이 입구정보와 하위 세대정보를 지웁니다. 맞습니까?"
        handleClose={handleConfirmDialogClose}
      />
    </Paper>
  );
}

export function BuildingView(props: any) {
  const { name, type, address } = props;

  const title = name === '' ? address.split(' ').at(-1) : name;
  return (
    <Grid container direction="column">
      <Typography variant="h6">{title}</Typography>
      {/* <Typography variant="body1"> 형태: {type}</Typography>
      <Typography variant="body1"> 주소: {address}</Typography> */}
    </Grid>
  );
}
